<template>
 <div id="qr-code" class="qr-code" :style="{'width': width, 'height': height}">
    <canvas id="my-canvas" :style="{'width': width, 'height': height}"></canvas>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import { download } from '@utils/basicUtil'
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    url: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '二维码'
    }
  },
  data () {
    return {
      imgUrl: ''
    }
  },
  watch: {
    url () {
      const qrCode = document.getElementById('qr-code')
      const img = document.getElementById('qr-code-img')
      qrCode.removeChild(img)
      this.renderQr()
    }
  },
  mounted () {
    this.renderQr()
    this.$on('downloadQrCode', this.downloadQrCode)
  },
  methods: {
    downloadQrCode () {
      download({ url: this.imgUrl, title: this.title })
    },
    renderQr () {
      const width = this.width
      const height = this.height
      const canvas = document.getElementById('my-canvas')
      const canvasContent = document.getElementById('qr-code')
      // 渲染二维码
      QRCode.toCanvas(
        canvas,
        this.url,
        { width, height, toSJISFunc: QRCode.toSJIS, margin: 3 },
        error => {
          console.log(error)
        }
      )
      // 转载成图片 canvas -> img
      const imgDom = new Image()
      imgDom.id = 'qr-code-img'
      imgDom.src = canvas.toDataURL('image/png')
      imgDom.alt = this.title
      imgDom.title = this.title
      imgDom.style.width = '100%'
      canvasContent.appendChild(imgDom)
      canvas.style.display = 'none'
      this.imgUrl = imgDom.src
    }
  }
}
</script>

<style scoped lang='less'>

</style>
